export enum SemanticColor {
    FillPrimary = 'fill/primary',
    FillPrimaryHovered = 'fill/primary/hovered',
    FillPrimaryPressed = 'fill/primary/pressed',
    FillPrimaryDisabled = 'fill/primary/disabled',

    FillSecondary = 'fill/secondary',
    FillSecondaryHovered = 'fill/secondary/hovered',
    FillSecondaryPressed = 'fill/secondary/pressed',
    FillSecondaryDisabled = 'fill/secondary/disabled',

    FillSecondaryOnDark = 'fill/secondary/on-dark',
    FillSecondaryOnDarkHovered = 'fill/secondary/on-dark/hovered',
    FillSecondaryOnDarkPressed = 'fill/secondary/on-dark/pressed',
    FillSecondaryOnDarkDisabled = 'fill/secondary/on-dark/disabled',

    FillTertiary = 'fill/tertiary',
    FillTertiaryHovered = 'fill/tertiary/hovered',
    FillTertiaryPressed = 'fill/tertiary/pressed',
    FillTertiaryDisabled = 'fill/tertiary/disabled',

    FillTertiaryInverted = 'fill/tertiary/inverted',
    FillTertiaryInvertedHovered = 'fill/tertiary/inverted/hovered',
    FillTertiaryInvertedPressed = 'fill/tertiary/inverted/pressed',
    FillTertiaryInvertedDisabled = 'fill/tertiary/inverted/disabled',

    FillTertiaryOnDark = 'fill/tertiary/on-dark',
    FillTertiaryOnDarkHovered = 'fill/tertiary/on-dark/hovered',
    FillTertiaryOnDarkPressed = 'fill/tertiary/on-dark/pressed',
    FillTertiaryOnDarkDisabled = 'fill/tertiary/on-dark/disabled',

    FillPositive = 'fill/positive',
    FillPositiveHovered = 'fill/positive/hovered',
    FillPositivePressed = 'fill/positive/pressed',
    FillPositiveDisabled = 'fill/positive/disabled',

    FillDestructive = 'fill/destructive',
    FillDestructiveHovered = 'fill/destructive/hovered',
    FillDestructivePressed = 'fill/destructive/pressed',
    FillDestructiveDisabled = 'fill/destructive/disabled',

    // Text tokens
    TextEmphasised = 'text/emphasised',
    TextEmphasisedHovered = 'text/emphasised/hovered',
    TextEmphasisedPressed = 'text/emphasised/pressed',

    TextPrimary = 'text/primary',
    TextPrimaryHovered = 'text/primary/hovered',
    TextPrimaryPressed = 'text/primary/pressed',
    TextPrimaryDisabled = 'text/primary/disabled',
    TextPrimaryInverted = 'text/primary/inverted',
    TextPrimaryInvertedDisabled = 'text/primary/inverted/disabled',
    TextPrimaryOnDarkFill = 'text/primary/on-dark/fill',
    TextPrimaryOnDarkFillDisabled = 'text/primary/on-dark/fill/disabled',

    TextSecondary = 'text/secondary',
    TextSecondaryOnDarkFill = 'text/secondary/on-dark/fill',
    TextSecondaryOnDarkFillDisabled = 'text/secondary/on-dark/fill/disabled',

    TextError = 'text/error',
    TextErrorDisabled = 'text/error/disabled',

    // Icon tokens
    IconEmphasised = 'icon/emphasised',
    IconEmphasisedDisabled = 'icon/emphasised/disabled',

    IconPrimary = 'icon/primary',
    IconPrimaryDisabled = 'icon/primary/disabled',
    IconPrimaryInverted = 'icon/primary/inverted',
    IconPrimaryInvertedDisabled = 'icon/primary/inverted/disabled',
    IconPrimaryOnDarkFill = 'icon/primary/on-dark/fill',
    IconPrimaryOnDarkFillDisabled = 'icon/primary/on-dark/fill/disabled',
    IconPrimaryOnLightFill = 'icon/primary/on-light/fill',

    IconSecondary = 'icon/secondary',
    IconSecondaryOnDarkFillDisabled = 'icon/secondary/on-dark/fill/disabled',

    IconTertiary = 'icon/tertiary',

    IconError = 'icon/error',
    IconErrorDisabled = 'icon/error/disabled',

    // Border tokens
    BorderEmphasised = 'border/emphasised',
    BorderEmphasisedDisabled = 'border/emphasised/disabled',
    BorderEmphasisedInvariable = 'border/emphasised/invariable',
    BorderEmphasisedInvariableDisabled = 'border/emphasised/invariable/disabled',

    BorderSemiemphasised = 'border/semiemphasised',

    BorderPrimary = 'border/primary',
    BorderPrimaryDisabled = 'border/primary/disabled',
    BorderPrimaryInvisible = 'border/primary/invisible',
    BorderPrimaryInvisibleDisabled = 'border/primary/invisible/disabled',

    BorderSecondary = 'border/secondary',

    BorderError = 'border/error',
    BorderErrorDisabled = 'border/error/disabled',

    // BG tokens
    BgEmphasised = 'bg/emphasised',
    BgEmphasisedMuted = 'bg/emphasised-muted',

    BgPrimary = 'bg/primary',
    BgPrimaryHovered = 'bg/primary/hovered',
    BgPrimaryPressed = 'bg/primary/pressed',
    BgPrimaryInvariable = 'bg/primary/invariable',
    BgPrimaryInverted = 'bg/primary/inverted',
    BgPrimaryTransparent = 'bg/primary/transparent',

    BgSecondary = 'bg/secondary',
    BgTertiary = 'bg/tertiary',
    BgTertiaryDisabled = 'bg/tertiary/disabled',

    BgError = 'bg/error',
    BgErrorMuted = 'bg/error/muted',

    // Overlay tokens
    OverlayDarkening = 'overlay/darkening',
    OverlayLightening = 'overlay/lightening',
    OverlayPrimary = 'overlay/primary',
    OverlaySecondary = 'overlay/secondary',
    OverlayFade0 = 'overlay/fade-0',
    OverlayFade100 = 'overlay/fade-100',
}

export const semanticColors = {
    // Fill tokens
    [SemanticColor.FillPrimary]: 'var(--fill-primary)',
    [SemanticColor.FillPrimaryHovered]: 'var(--fill-primary-hovered)',
    [SemanticColor.FillPrimaryPressed]: 'var(--fill-primary-pressed)',
    [SemanticColor.FillPrimaryDisabled]: 'var(--fill-primary-disabled)',

    [SemanticColor.FillSecondary]: 'var(--fill-secondary)',
    [SemanticColor.FillSecondaryHovered]: 'var(--fill-secondary-hovered)',
    [SemanticColor.FillSecondaryPressed]: 'var(--fill-secondary-pressed)',
    [SemanticColor.FillSecondaryDisabled]: 'var(--fill-secondary-disabled)',

    [SemanticColor.FillSecondaryOnDark]: 'var(--fill-secondary-on-dark)',
    [SemanticColor.FillSecondaryOnDarkHovered]: 'var(--fill-secondary-on-dark-hovered)',
    [SemanticColor.FillSecondaryOnDarkPressed]: 'var(--fill-secondary-on-dark-pressed)',
    [SemanticColor.FillSecondaryOnDarkDisabled]: 'var(--fill-secondary-on-dark-disabled)',

    [SemanticColor.FillTertiary]: 'var(--fill-tertiary)',
    [SemanticColor.FillTertiaryHovered]: 'var(--fill-tertiary-hovered)',
    [SemanticColor.FillTertiaryPressed]: 'var(--fill-tertiary-pressed)',
    [SemanticColor.FillTertiaryDisabled]: 'var(--fill-tertiary-disabled)',

    [SemanticColor.FillTertiaryInverted]: 'var(--fill-tertiary-inverted)',
    [SemanticColor.FillTertiaryInvertedHovered]: 'var(--fill-tertiary-inverted-hovered)',
    [SemanticColor.FillTertiaryInvertedPressed]: 'var(--fill-tertiary-inverted-pressed)',
    [SemanticColor.FillTertiaryInvertedDisabled]: 'var(--fill-tertiary-inverted-disabled)',

    [SemanticColor.FillTertiaryOnDark]: 'var(--fill-tertiary-on-dark)',
    [SemanticColor.FillTertiaryOnDarkHovered]: 'var(--fill-tertiary-on-dark-hovered)',
    [SemanticColor.FillTertiaryOnDarkPressed]: 'var(--fill-tertiary-on-dark-pressed)',
    [SemanticColor.FillTertiaryOnDarkDisabled]: 'var(--fill-tertiary-on-dark-disabled)',

    [SemanticColor.FillPositive]: 'var(--fill-positive)',
    [SemanticColor.FillPositiveHovered]: 'var(--fill-positive-hovered)',
    [SemanticColor.FillPositivePressed]: 'var(--fill-positive-pressed)',
    [SemanticColor.FillPositiveDisabled]: 'var(--fill-positive-disabled)',

    [SemanticColor.FillDestructive]: 'var(--fill-destructive)',
    [SemanticColor.FillDestructiveHovered]: 'var(--fill-destructive-hovered)',
    [SemanticColor.FillDestructivePressed]: 'var(--fill-destructive-pressed)',
    [SemanticColor.FillDestructiveDisabled]: 'var(--fill-destructive-disabled)',

    // Text tokens
    [SemanticColor.TextEmphasised]: 'var(--text-emphasised)',
    [SemanticColor.TextEmphasisedHovered]: 'var(--text-emphasised-hovered)',
    [SemanticColor.TextEmphasisedPressed]: 'var(--text-emphasised-pressed)',

    [SemanticColor.TextPrimary]: 'var(--text-primary)',
    [SemanticColor.TextPrimaryHovered]: 'var(--text-primary-hovered)',
    [SemanticColor.TextPrimaryPressed]: 'var(--text-primary-pressed)',
    [SemanticColor.TextPrimaryDisabled]: 'var(--text-primary-disabled)',
    [SemanticColor.TextPrimaryInverted]: 'var(--text-primary-inverted)',
    [SemanticColor.TextPrimaryInvertedDisabled]: 'var(--text-primary-inverted-disabled)',
    [SemanticColor.TextPrimaryOnDarkFill]: 'var(--text-primary-on-dark-fill)',
    [SemanticColor.TextPrimaryOnDarkFillDisabled]: 'var(--text-primary-on-dark-fill-disabled)',

    [SemanticColor.TextSecondary]: 'var(--text-secondary)',
    [SemanticColor.TextSecondaryOnDarkFill]: 'var(--text-secondary-on-dark-fill)',
    [SemanticColor.TextSecondaryOnDarkFillDisabled]: 'var(--text-secondary-on-dark-fill-disabled)',

    [SemanticColor.TextError]: 'var(--text-error)',
    [SemanticColor.TextErrorDisabled]: 'var(--text-error-disabled)',

    // Icon tokens
    [SemanticColor.IconEmphasised]: 'var(--icon-emphasised)',
    [SemanticColor.IconEmphasisedDisabled]: 'var(--icon-emphasised-disabled)',

    [SemanticColor.IconPrimary]: 'var(--icon-primary)',
    [SemanticColor.IconPrimaryDisabled]: 'var(--icon-primary-disabled)',
    [SemanticColor.IconPrimaryInvertedDisabled]: 'var(--icon-primary-inverted-disabled)',
    [SemanticColor.IconPrimaryInverted]: 'var(--icon-primary-inverted)',
    [SemanticColor.IconPrimaryOnDarkFill]: 'var(--icon-primary-on-dark-fill)',
    [SemanticColor.IconPrimaryOnDarkFillDisabled]: 'var(--icon-primary-on-dark-fill-disabled)',
    [SemanticColor.IconPrimaryOnLightFill]: 'var(--icon-primary-on-light-fill)',

    [SemanticColor.IconSecondary]: 'var(--icon-secondary)',
    [SemanticColor.IconSecondaryOnDarkFillDisabled]: 'var(--icon-secondary-on-dark-fill-disabled)',

    [SemanticColor.IconTertiary]: 'var(--icon-tertiary)',

    [SemanticColor.IconError]: 'var(--icon-error)',
    [SemanticColor.IconErrorDisabled]: 'var(--icon-error-disabled)',

    // Border tokens
    [SemanticColor.BorderEmphasised]: 'var(--border-emphasised)',
    [SemanticColor.BorderEmphasisedDisabled]: 'var(--border-emphasised-disabled)',
    [SemanticColor.BorderEmphasisedInvariable]: 'var(--border-emphasised-invariable)',
    [SemanticColor.BorderEmphasisedInvariableDisabled]: 'var(--border-emphasised-invariable-disabled)',

    [SemanticColor.BorderSemiemphasised]: 'var(--border-semiemphasised)',

    [SemanticColor.BorderPrimary]: 'var(--border-primary)',
    [SemanticColor.BorderPrimaryDisabled]: 'var(--border-primary-disabled)',
    [SemanticColor.BorderPrimaryInvisible]: 'var(--border-primary-invisible)',
    [SemanticColor.BorderPrimaryInvisibleDisabled]: 'var(--border-primary-invisible-disabled)',

    [SemanticColor.BorderSecondary]: 'var(--border-secondary)',

    [SemanticColor.BorderError]: 'var(--border-error)',
    [SemanticColor.BorderErrorDisabled]: 'var(--border-error-disabled)',

    // BG tokens
    [SemanticColor.BgEmphasised]: 'var(--bg-emphasised)',
    [SemanticColor.BgEmphasisedMuted]: 'var(--bg-emphasised-muted)',

    [SemanticColor.BgPrimary]: 'var(--bg-primary)',
    [SemanticColor.BgPrimaryHovered]: 'var(--bg-primary-hovered)',
    [SemanticColor.BgPrimaryPressed]: 'var(--bg-primary-pressed)',
    [SemanticColor.BgPrimaryInvariable]: 'var(--bg-primary-invariable)',
    [SemanticColor.BgPrimaryInverted]: 'var(--bg-primary-inverted)',
    [SemanticColor.BgPrimaryTransparent]: 'var(--bg-primary-transparent)',

    [SemanticColor.BgSecondary]: 'var(--bg-secondary)',
    [SemanticColor.BgTertiary]: 'var(--bg-tertiary)',
    [SemanticColor.BgTertiaryDisabled]: 'var(--bg-tertiary-disabled)',

    [SemanticColor.BgError]: 'var(--bg-error)',
    [SemanticColor.BgErrorMuted]: 'var(--bg-error-muted)',

    // Overlay tokens
    [SemanticColor.OverlayDarkening]: 'var(--overlay-darkening)',
    [SemanticColor.OverlayLightening]: 'var(--overlay-lightening)',
    [SemanticColor.OverlayPrimary]: 'var(--overlay-primary)',
    [SemanticColor.OverlaySecondary]: 'var(--overlay-secondary)',
    [SemanticColor.OverlayFade0]: 'var(--overlay-fade-0)',
    [SemanticColor.OverlayFade100]: 'var(--overlay-fade-100)',
} as const;

export const colors = {
    // General colors
    white_base: 'var(--white_base)',
    white_0_tr_base: 'var(--white_0_tr_base)',
    white_8_tr_base: 'var(--white_8_tr_base)',
    white_16_tr_base: 'var(--white_16_tr_base)',
    white_40_tr_base: 'var(--white_40_tr_base)',
    white_72_tr_base: 'var(--white_72_tr_base)',
    black_48_tr_base: 'var(--black_48_tr_base)',
    purple_0_tr_base: 'var(--purple_0_tr_base)',

    // Theme colors
    white: 'var(--white)',
    white_72_tr: 'var(--white_72_tr)',
    black: 'var(--black)',
    permanent_black: 'var(--permanent_black)',
    permanent_white: 'var(--permanent_white)',
    'button-white/hovered': 'var(--button-white-hovered)',
    'button-white/pressed': 'var(--button-white-pressed)',

    grey_8_lc: 'var(--grey_8_lc)',
    grey_16_lc: 'var(--grey_16_lc)',
    grey_40_lc: 'var(--grey_40_lc)',
    grey_72_lc: 'var(--grey_72_lc)',
    grey_16_tr: 'var(--grey_16_tr)',
    grey_28_tr: 'var(--grey_28_tr)',

    purple_8_lc: 'var(--purple_8_lc)',
    purple_16_lc: 'var(--purple_16_lc)',
    purple_24_lc: 'var(--purple_24_lc)',
    purple_40_lc: 'var(--purple_40_lc)',
    purple_72_lc: 'var(--purple_72_lc)',
    purple_100: 'var(--purple_100)',
    purple_72_hc: 'var(--purple_72_hc)',
    purple_8_tr: 'var(--purple_8_tr)',
    purple_16_tr: 'var(--purple_16_tr)',
    purple_24_tr: 'var(--purple_24_tr)',
    purple_40_tr: 'var(--purple_40_tr)',
    purple_72_tr: 'var(--purple_72_tr)',

    pink_8_lc: 'var(--pink_8_lc)',
    pink_16_lc: 'var(--pink_16_lc)',
    pink_40_lc: 'var(--pink_40_lc)',
    pink_72_lc: 'var(--pink_72_lc)',
    pink_100: 'var(--pink_100)',
    pink_8_tr: 'var(--pink_8_tr)',
    pink_16_tr: 'var(--pink_16_tr)',
    pink_40_tr: 'var(--pink_40_tr)',
    pink_72_tr: 'var(--pink_72_tr)',

    // NEW Colors
    // black
    'black-0-tr': 'var(--black-0-tr)',
    'black-4-tr': 'var(--black-4-tr)',
    'black-8-tr': 'var(--black-8-tr)',
    'black-16-tr': 'var(--black-16-tr)',
    'black-40-tr': 'var(--black-40-tr)',
    'black-72-tr': 'var(--black-72-tr)',
    'black-80-tr': 'var(--black-80-tr)',
    'black-80-lc': 'var(--black-80-lc)',
    'black-88-tr': 'var(--black-88-tr)',
    'black-88-lc': 'var(--black-88-lc)',
    'black-96-tr': 'var(--black-96-tr)',
    'black-100': 'var(--black-100)',

    // white
    'white-0-tr': 'var(--white-0-tr)',
    'white-4-tr': 'var(--white-4-tr)',
    'white-8-tr': 'var(--white-8-tr)',
    'white-16-tr': 'var(--white-16-tr)',
    'white-40-tr': 'var(--white-40-tr)',
    'white-72-tr': 'var(--white-72-tr)',
    'white-80-tr': 'var(--white-80-tr)',
    'white-80-lc': 'var(--white-80-lc)',
    'white-88-tr': 'var(--white-88-tr)',
    'white-88-lc': 'var(--white-88-lc)',
    'white-96-tr': 'var(--white-96-tr)',
    'white-100': 'var(--white-100)',

    // gray-warm
    'gray-warm-8-lc': 'var(--gray-warm-8-lc)',
    'gray-warm-16-lc': 'var(--gray-warm-16-lc)',
    'gray-warm-16-tr': 'var(--gray-warm-16-tr)',
    'gray-warm-40-lc': 'var(--gray-warm-40-lc)',
    'gray-warm-72-lc': 'var(--gray-warm-72-lc)',

    // gray-cold
    'gray-cold-8-lc': 'var(--gray-cold-8-lc)',
    'gray-cold-16-lc': 'var(--gray-cold-16-lc)',
    'gray-cold-16-tr': 'var(--gray-cold-16-tr)',
    'gray-cold-40-lc': 'var(--gray-cold-40-lc)',
    'gray-cold-56-lc': 'var(--gray-cold-56-lc)',
    'gray-cold-72-lc': 'var(--gray-cold-72-lc)',

    // pink-vivid
    'pink-vivid-8-lc': 'var(--pink-vivid-8-lc)',
    'pink-vivid-8-tr': 'var(--pink-vivid-8-tr)',
    'pink-vivid-16-lc': 'var(--pink-vivid-16-lc)',
    'pink-vivid-16-tr': 'var(--pink-vivid-16-tr)',
    'pink-vivid-40-lc': 'var(--pink-vivid-40-lc)',
    'pink-vivid-40-tr': 'var(--pink-vivid-40-tr)',
    'pink-vivid-72-lc': 'var(--pink-vivid-72-lc)',
    'pink-vivid-72-tr': 'var(--pink-vivid-72-tr)',
    'pink-vivid-100': 'var(--pink-vivid-100)',

    // pink-muted
    'pink-muted-8-lc': 'var(--pink-muted-8-lc)',
    'pink-muted-8-tr': 'var(--pink-muted-8-tr)',
    'pink-muted-16-lc': 'var(--pink-muted-16-lc)',
    'pink-muted-16-tr': 'var(--pink-muted-16-tr)',
    'pink-muted-40-lc': 'var(--pink-muted-40-lc)',
    'pink-muted-40-tr': 'var(--pink-muted-40-tr)',
    'pink-muted-72-lc': 'var(--pink-muted-72-lc)',
    'pink-muted-72-tr': 'var(--pink-muted-72-tr)',
    'pink-muted-100': 'var(--pink-muted-100)',

    // accents
    'blue-16-tr': 'var(--blue-16-tr)',
    'blue-100': 'var(--blue-100)',
    'green-16-tr': 'var(--green-16-tr)',
    'green-100': 'var(--green-100)',
    'orange-16-tr': 'var(--orange-16-tr)',
    'orange-100': 'var(--orange-100)',
    'red-16-tr': 'var(--red-16-tr)',
    'red-100': 'var(--red-100)',

    // overlay-only
    'pure-black-0-tr': 'var(--pure-black-0-tr)',
    'pure-black-16-tr': 'var(--pure-black-16-tr)',
    'pure-black-40-tr': 'var(--pure-black-40-tr)',
    'pure-black-72-tr': 'var(--pure-black-72-tr)',
} as const;

export const gradients = {
    'gradient-aubergine_1': 'var(--gradient-aubergine_1)',
    'gradient-aubergine_2': 'var(--gradient-aubergine_2)',
    'gradient-aubergine_3': 'var(--gradient-aubergine_3)',
    'gradient-blue_1': 'var(--gradient-blue_1)',
    'gradient-blue_2': 'var(--gradient-blue_2)',
    'gradient-blue_3': 'var(--gradient-blue_3)',
    'gradient-passionFruit_1': 'var(--gradient-passionFruit_1)',
    'gradient-passionFruit_2': 'var(--gradient-passionFruit_2)',
    'gradient-passionFruit_3': 'var(--gradient-passionFruit_3)',
} as const;

export const shadows = {
    shadow_purple: 'var(--shadow_purple)',
    shadow_grey: 'var(--shadow_grey)',
    'shadow-grey-1': 'var(--shadow-grey-1)',
    'shadow-grey-2': 'var(--shadow-grey-2)',
    'shadow-grey-3': 'var(--shadow-grey-3)',
    shadow_grey_1: 'var(--shadow_grey_1)',
    'shadow-float-secondary': 'var(--shadow-float-secondary)',
} as const;

export type SemanticColorToken = SemanticColor | `${SemanticColor}`;
export type ColorToken = keyof typeof colors;
export type GradientToken = keyof typeof gradients;
export type ShadowToken = keyof typeof shadows;
